import { useTranslation } from 'react-i18next';

interface OtpTimerProps {
  timeLeft: number;
  active: boolean;
  onResend: () => void;
}

const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const remainingSeconds = (seconds % 60).toString().padStart(2, '0');
  return `${minutes}:${remainingSeconds}`;
};

const OtpTimer = ({ timeLeft, active, onResend }: OtpTimerProps) => {
  const { t } = useTranslation();

  if (active) {
    return (
      <span className="text-[11px] text-registerText">
        {t('auth.otpTimer.resendIn', { time: formatTime(timeLeft) })}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onResend}
      className="text-[11px] font-semibold text-[#ff9500] hover:underline"
    >
      {t('auth.otpTimer.resend')}
    </button>
  );
};

export default OtpTimer;
